import React, { useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Paper, Typography } from '@mui/material';
import { checkAuthStatus } from '../services/authService';

const labels: Record<string, string> = {
    email: 'Email',
    phone_number: 'Telefono',
    ragione_sociale: 'Ragione Sociale',
    partita_iva: 'Partita IVA',
    codice_fiscale: 'Codice Fiscale',
    pec: 'PEC'
};

export default function Profile() {
    const cachedUser = (() => {
        try {
            return JSON.parse(sessionStorage.getItem('user') || 'null');
        } catch {
            return null;
        }
    })();
    const [user, setUser] = useState<Record<string, any> | null>(cachedUser);
    const [error, setError] = useState('');

    useEffect(() => {
        checkAuthStatus()
            .then(data => data.authenticated && data.user
                ? setUser(data.user)
                : Promise.reject(new Error('Profilo non disponibile')))
            .catch(err => {
                // Il layout ha gia caricato i dati utente: usali se lo status API
                // fallisce durante un cambio pagina o una sessione in rinnovo.
                if (!cachedUser) setError(err.message);
            });
    }, []);

    if (error) return <Alert severity="error">{error}</Alert>;
    if (!user) return <CircularProgress />;

    const address = user.sede_legale || {};
    const fields = Object.entries(labels).map(([key, label]) => ({ label, value: user[key] || '-' }));
    fields.push({ label: 'Indirizzo', value: address.indirizzo || '-' });
    fields.push({ label: 'Civico', value: address.civico || '-' });
    fields.push({ label: 'CAP', value: address.cap || '-' });
    fields.push({ label: 'Comune', value: address.comune || '-' });
    fields.push({ label: 'Provincia', value: address.provincia || '-' });

    return <Box sx={{ maxWidth: 900 }}>
        <Paper sx={{
            p: { xs: 2, sm: 3 },
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
            gap: { xs: 2, sm: 2.5 },
            borderRadius: 1.5,
            boxShadow: '0 1px 3px rgba(0, 0, 0, 0.12)'
        }}>
            {fields.map(field => <Box key={field.label}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.35, letterSpacing: 0.2 }}>
                    {field.label}
                </Typography>
                <Typography sx={{ fontWeight: 500, wordBreak: 'break-word' }}>{field.value}</Typography>
            </Box>)}
        </Paper>
    </Box>;
}
